module.exports = __webpack_public_path__ + "img/influence.8bf4c10.jpg";